export default __webpack_public_path__ + "static/media/round.f5d2afdb.svg";